<!-- Do not change this file. -->
<template>
  <div class="alert alert-danger d-flex justify-content-between gap-3">
    <div class="text-dark h4 fw-bold">Reset All User Data</div>
    <button
      class="btn btn-danger fw-bold flex-grow-1"
      @click="clearData()"
      :disabled="isResetting"
    >
      <span v-if="isResetting">
        <span
          class="spinner-border spinner-border-sm me-2"
          aria-hidden="true"
        ></span>
        <span class="visually-hidden">Resetting...</span>
      </span>
      <span v-else>Reset All Data</span>
    </button>
  </div>
</template>

<script>
/* Do not change this file. */

import DatastoreAPI from "@/helpers/DatastoreAPI";

export default {
  name: "AdminReset",
  mixins: [DatastoreAPI],
  data() {
    return {
      isResetting: false
    };
  },
  methods: {
    clearData() {
      if (confirm("Reset all data?")) {
        this.isResetting = true;
        this.deleteEntries(() => {
          this.isResetting = false;
          // reload the page
          location.reload();
        });
      }
    }
  }
};
</script>
